export type MsmeAuthFeatureIcon =
  | "onboarding"
  | "catalogue"
  | "account"
  | "inventory"
  | "logistics"
  | "visibility";

export type MsmeAuthFeatureColorScheme = "blue" | "orange" | "green" | "purple";

export interface MsmeAuthFeatureItem {
  title: string;
  description: string;
  icon: MsmeAuthFeatureIcon;
  colorScheme: MsmeAuthFeatureColorScheme;
}

export interface MsmeAuthHighlightItem {
  title: string;
  description: string;
  emphasis: string;
  tone: "info" | "success";
}

export const MSME_AUTH_MARKETING = {
  title: "Features of MSME Global Mart 2.0",
  features: [
    {
      title: "Onboarding of MSMEs on ONDC Network",
      description:
        "Streamlined verification process to integrate your entity natively onto the open networks protocol seamlessly.",
      icon: "onboarding",
      colorScheme: "blue",
    },
    {
      title: "Smart Cataloguing",
      description:
        "Organize, transform, and publish dynamic product sheets or services with unified taxonomy standards.",
      icon: "catalogue",
      colorScheme: "orange",
    },
    {
      title: "Account Management",
      description:
        "Complete control over your legal business profile, verified bank details, ledgers, and transaction payouts.",
      icon: "account",
      colorScheme: "green",
    },
    {
      title: "Automated Buyer Visibility",
      description:
        "Once items are active in your inventory, enjoy instantaneous Visibility of onboarded MSMEs on buyer apps such as DIGIHAAT.",
      icon: "visibility",
      colorScheme: "purple",
    },
    // {
    //   title: "Inventory Management",
    //   description:
    //     "Real-time stock balance tracking with instantaneous state updates preventing overselling across multi-channel interfaces.",
    //   icon: "inventory",
    //   colorScheme: "green",
    // },
    // {
    //   title: "Logistics Management",
    //   description:
    //     "Native dynamic routing choices. Select and integrate with local, regional, or national fulfillment network players easily.",
    //   icon: "logistics",
    //   colorScheme: "orange",
    // },
  ] satisfies MsmeAuthFeatureItem[],
  highlights: [
    // {
    //   title: "Direct Order Infrastructure",
    //   description: "Process seamless, instant",
    //   emphasis: "Order placement through Buyer Apps (BNP) of ONDC",
    //   tone: "success",
    // },
  ] satisfies MsmeAuthHighlightItem[],
};
